import { themeColor, themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import { styled } from '@styledComponents';
import { Box } from '@components/Box';
import { Text } from '@components/typography';
import { Flex } from '@components/Flex';

export const CoupleContainer = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff9f5;
`;

export const ResponseWrapper = styled(Box)<{ isReady: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 400px;
  background-color: ${props => (props.isReady ? themeColor('white') : '#FFF9F5')};
`;

export const CountText = styled(Text)<{ error: Boolean }>`
  color: ${({ error }) => (error ? themeColor('red5') : '#333333')};
  align-self: flex-start;
`;

export const ResultList = styled(Box)`
  width: 100%;
  max-width: 1225px;
  display: flex;
  flex-direction: column;
  padding-top: ${themeSpace(7)};
  padding-bottom: ${themeSpace(7)};
  margin-bottom: ${themeSpace(12)};
  padding-left: 50px;
  padding-right: 50px;
  ${themeMediaQuery('below_sm')} {
    padding-left: 35px;
    padding-right: 0px;
  }
`;

export const NoDataMsg = styled(Text)`
  width: 100%;
  color: #333333;
  padding-top: ${themeSpace(5)};
  padding-bottom: ${themeSpace(5)};
  line-height: 45px;
`;

export const ListItemWrapper = styled(Box)`
  column-gap: ${themeSpace(8)};
  min-height: 128px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid #fff3e8;
  padding-top: ${themeSpace(5)};
  padding-bottom: ${themeSpace(5)};
  align-items: center;
  ${themeMediaQuery('below_sm')} {
    flex-direction: column;
    align-items: flex-start;
  }
  ${themeMediaQuery('sm')} {
    column-gap: ${themeSpace(6)};
  }
  ${themeMediaQuery('md')} {
    column-gap: ${themeSpace(8)};
  }
`;

export const DetailField = styled(Box)`
  width: auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  ${themeMediaQuery('below_sm')} {
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
    padding-left: 70px;
  }
`;

export const NameField = styled(Text)`
  color: #333333;
  cursor: pointer;
  &:hover {
    color: ${themeColor('linkHover')};
  }
  &:active {
    color: ${themeColor('linkPress')};
  }
  ${themeMediaQuery('below_sm')} {
    span.fiancee {
      display: block;
    }
  }
`;

export const DateField = styled(Text)`
  color: #595959;
  min-width: 135px;
  text-align: left;
  margin-right: 64px;
  ${themeMediaQuery('below_sm')} {
    line-height: 3;
    display: block;
    margin-right: 0;
  }
`;

export const LinksWrapper = styled(Box)`
  display: inline-flex;
  flex-direction: row;
  justify-content: space-between;
  min-width: 234px;

  ${themeMediaQuery('below_sm')} {
    min-width: 159px;
    padding-left: ${themeSpace(0)};
    padding-right: ${themeSpace(0)};
    a {
      padding-left: ${themeSpace(0)};
      padding-right: ${themeSpace(0)};
    }
  }
`;

export const ProfileWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 17px;
`;

export const BoulderContainer = styled(Flex)`
  width: 100%;
  justify-content: space-between;
  ${themeMediaQuery('below_sm')} {
    position: fixed;
    bottom: 0;
  }
`;

export const ListContainer = styled(Flex)`
  margin-top: ${themeSpace(5)};
`;
